import { render, staticRenderFns } from "./PayrollDetailsReportView.vue?vue&type=template&id=0e8787f9&scoped=true&"
import script from "./PayrollDetailsReportView.vue?vue&type=script&lang=ts&"
export * from "./PayrollDetailsReportView.vue?vue&type=script&lang=ts&"
import style0 from "./PayrollDetailsReportView.vue?vue&type=style&index=0&id=0e8787f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8787f9",
  null
  
)

export default component.exports